const faqArray = [
  {
    faqTitle: 'Is this really what your wedding site looks like?',
    faqAnswer:
      'Well, yes and no. This is what the UI looks like, but obviously the text is gibberish, just for those that do not have the real password.',
  },
  {
    faqTitle: 'Why are you sharing this with us?',
    faqAnswer:
      "I don't have a large portfolio to show off, given that while I did get my certification in web development, I do still have a full time job. I knew I wanted to build my own wedding website, and I'm really proud of it, so I am happy to share the work I have done on it. Plus, you can get a glimpse into my life outside of a resume or a cover letter :)",
  },
  {
    faqTitle:
      "How can we trust you'll be good on the job give you've only developed Shiny apps? ",
    faqAnswer:
      "Yes, while it's true I've only done development on Shiny apps during my career, at the fundamental level, it is the same as building React apps. I have built extremely complicated apps that involve working with many pieces of logic to come together. I know how to think about the problem and find a way to make it work. The only difference is the syntax. I found this to be very true while working on my certification - I knew what I needed to get done in order to accomplish the task, I just had to figure out how to translate the R syntax into Javascript. Not to mention, Javascript HTML and CSS are all under the hood of Shiny, so I do have experience manipulating that in order to get a better application. ",
  },
  {
    faqTitle: 'Is there anything else we should know?',
    faqAnswer:
      'I am actively trying to continue to build my portfolio to showcase my desire for transfering into a frontend developer/software engineer position. I am working on rebuilidng my personal website (which I built before my web development certification) from a Shiny app to a React app. ',
  },
];
export default faqArray;
